/**
 * Stacking for PaymentProceedModal over parent wallet dialogs.
 *
 * Confirm Payment (QR) and several other forms set DialogContent
 * `zIndex: 9999`. The shared Radix dialog primitive uses `z-50` (50).
 * If the proceed modal stays at 50, "Review payment" / Pay opens it
 * underneath the parent — the user sees no change and initiate never runs.
 */
export const PARENT_DIALOG_Z_INDEX_CEILING = 9999;
export const PAYMENT_PROCEED_MODAL_Z_INDEX = 10050;

export function proceedsAboveParentDialog(parentZIndex: number): boolean {
  return PAYMENT_PROCEED_MODAL_Z_INDEX > parentZIndex;
}
